import Vue from 'vue';
import VTiptap from "@peepi/vuetify-tiptap";

Vue.use(VTiptap)

export default VTiptap;